import React from 'react';
import DropdownsContainer from '../../Componant/UiKits/Dropdown';

const Dropdowns = () => {
  return (
    <div className='page-body'>
      <DropdownsContainer />
    </div>
  );
};

export default Dropdowns;
